export type RewardPopupDetail = {
  title: string;
  rewardImageUrl: string;
  frameImageUrl?: string;
  buttonLabel?: string;
};

export const REWARD_POPUP_EVENT = "puppy:reward-popup";

export function showRewardPopup(detail: RewardPopupDetail): void {
  window.dispatchEvent(
    new CustomEvent<RewardPopupDetail>(REWARD_POPUP_EVENT, {
      detail,
    })
  );
}

